<template>
<main class="bg-main play-script lesson-multiaudio" :class="{ 'driver-fix-stacking': onDriver}">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>
  <section class="container">
     <div class="heading-content-title">
      <div>{{ $t('lesson.script.title') }}</div>
      <div class="translation" v-if="selectedLanguage.key != 'ja' && levelLabel != 'n2'">
      {{ $t('lesson.script.button.translation_on') }}
      <a class="toggle" 
      :class="{ 'on' : showTranslation }"
      @click.prevent="toggleTranslation">
      </a>
      </div>
    </div>
  
    <!-- Script -->
    <div class="lesson-script">

      <!-- Character's Line(s) -->
      <!-- Character's Picture and Name -->
      <template v-for="(line, lineindex) in scriptData.content.dialogue">
      <div class="character" :id="`character-${lineindex}`">
        <div class="character-info">
          <img class="character-image" :src="line.image">
          <p class="character-name">{{line.character}}</p>
        </div>

        <!-- Character's Speech Bubble -->
        <div class="speech">
          <div class="speech-bubble" :class="{ 'on' : audioIndex == lineindex }">
            <div class="speech-bubble-triangle"></div>
            <p class="jp">{{line.jp_dialogue}}</p>
            <p class="script-translation" v-if="selectedLanguage.key != 'ja'" v-show="showTranslation">
              {{ translationLang(line) }}
            </p>
          </div>
        </div>
      </div>
      </template>
      <!-- End of Character's Line(s) -->

    </div>
    <!-- End of Script --> 
  
  </section>
  <div class="sticky" :class="{ 'driver-fix-stacking': onDriver}">
    <div class="script-buttons">
      <lessonmultiaudio v-if="scriptData.content.dialogue && audioType" :audioList="scriptData.content.dialogue" :audioType="audioType" @playevent="audioPlayEvent"></lessonmultiaudio>
      <div class="buttons-side-by-side">
        <a  class="button button-default back" @click="goBack">{{ $t('common.button.back') }}</a>
        <a class="button button-primary next" @click.prevent="completedLesson">{{ $t('common.button.next') }}</a>
      </div>
    </div>
  </div>

</main>

</template>

<script>
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {api, appEnv, useCoachmark} from "../../config";
import {mapState} from 'vuex';
import {mapGetters} from 'vuex';

import componentContentHead from '../shared/ContentHead.vue';
import LessonMultiAudio from './LessonMultiAudio.vue'
  
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

export default {
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonmultiaudio': LessonMultiAudio,
  },
  data () {
    return {
      step: 'script',
      showTranslation: false,
      audioType: 'audio',
      audioIndex: null,
      driver: null,
      showDriver: false,
      storage: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth,
    }),
    ...mapGetters([
      'selectedLanguage'
    ]),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    scriptData() {
      return this.$store.getters.lesson_content.script ? this.$store.getters.lesson_content.script : {content: { title: '', dialogue: ''}}
    },
    introductionContent() {
      return this.$store.getters.lesson_content.introduction ? this.$store.getters.lesson_content.introduction : {content: { title: '', body: ''}}
    },
    translationLang: function() {
      return function(line) {
        let dialogue = this.$store.getters.selectedLanguage.key + '_dialogue'
        if (dialogue in line) {
          return line[dialogue]
        }
        return line['en_dialogue']
      }
    },
    onDriver() {
      return this.showDriver
    },
    levelLabel() {
      const currentSection = this.$store.getters.section_data
      if(currentSection && (currentSection.level == 'N4' || currentSection.level == 'N5')) {
        return currentSection.level.toLowerCase();
      } else if(currentSection && (currentSection.level == 'n3' || currentSection.level == 'N3')) {
        return 'n3';
      } else if(currentSection && (currentSection.level == 'n2' || currentSection.level == 'N2')) {
        return 'n2';
      } else {
        return '';
      }
    },
  },

  created() {
      this.authUser = this.$store.getters.getAuthUser;
      
      this.showDriver = false
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
  },
  mounted() {
      if(useCoachmark) {
        this.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
        
        const isCoachmarkDone = this.storage.getItem("coachmarkdone") ? JSON.parse(this.storage.getItem("coachmarkdone")) : null;
        if(!(isCoachmarkDone && this.step in isCoachmarkDone && isCoachmarkDone[this.step])) {
          this.showCoachMark();
        }
      }
  },
  methods: {
    audioPlayEvent: function(value) {
      if(this.driver) {
        this.driver.reset();
      }
      
      this.audioIndex = value.index;
      let lessonScript = document.getElementsByClassName('lesson-script')[0];
      let scrollElement = document.getElementById('character-' + value.index);
      let subHeight = window.outerHeight - (90 + 176);
      if(lessonScript.offsetHeight > scrollElement.offsetTop && subHeight < scrollElement.offsetTop) {
        scrollElement.scrollIntoView({
          behavior: 'smooth',
          block : 'start'
        });
      }
    },
    toggleTranslation() {
      if(this.driver) {
        this.driver.reset();
      }
      this.showTranslation = !this.showTranslation
    },
    completedLesson() {
      let self = this;
      const status_content = async function() {
        if (self.$store.getters.lesson_content[self.step].status != 'completed') {
          self.statusContent('completed', self.step);
          self.$store.dispatch('updateLessonContentStatus', {type: 'script', status: 'completed' });
        }
      }
      const status_lesson = async function() {
        if (self.$store.getters.lesson_status != 'completed') {
          self.statusLesson('completed');
        }
      }

      // Run synchronously
      const processAll = async function() {
        await status_content()
        await status_lesson()

        self.learningTempLog();
        // Update Log
        self.learningLog();

        self.$router.push({ name: 'region', params: {region: self.$store.getters.section_data.section} })
      }
      processAll()
    },
    goBack() {
      this.$router.push({name: 'lesson.explanation', params: {step: 'listening_practice'}});
    },
    initCoachMark() {
      if(this.driver) {
        this.driver.reset()
      } else {
        const driverOverlay = document.getElementById('driver-page-overlay')
        const driverStage = document.getElementById('driver-highlighted-element-stage')
        const driverItem = document.getElementById('driver-popover-item')
        const driverItem2 = document.getElementById('driver-popover-item2')
        
        if(driverOverlay) {
          driverOverlay.remove()
        }
        if(driverStage) {
          driverStage.remove()
        }
        if(driverItem) {
          driverItem.remove()
        }
      }
    },
    showCoachMark() {
      let self = this;
      if(!this.authUser) return false;
      
      this.showDriver = true
      
       this.driver = new Driver({
          className: "scoped-class-dark",
          animate: true,
          opacity: 0.7,
          padding: 10,
          stageBackground: 'rgba(255, 255, 255, 0.5)',
          allowClose: true,
          overlayClickNext: false,
          DoneBtnText: "Done",
          CloseBtnText: "Close",
          NextBtnText: "Next",
          PrevBtnText: "Previous step",
          onDeselected: (e) => {
            if(this.driver.hasNextStep()) {
              return false
            }
          },
          onReset: (e) => {
            if(this.driver.hasNextStep()) {
              if((e &&'popover' in e) && !e.popover.node.classList.contains('popover-last')) {
                setTimeout(() => {
                  this.driver.start(1);
                }, 500)
                return true
              }
            }
            this.showDriver = false
            let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
            if(!coachMarks) {
              coachMarks = {};
              coachMarks[this.step] = true;
            } else {
              coachMarks[this.step] = true;
            }

            this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
          }
      })
      
      if(this.levelLabel == "n2") {
        this.driver.defineSteps([
        {
          element: ".buttons-audio",
          popover: {
            className: 'popover-class show-button popover-last title-left footer-left',
            title: 'click to Play',
            position: 'top',
          }
        }
        ]);
      } else {
        this.driver.defineSteps([
        {
          element: '.heading-content-title .translation',
          popover: {
            className: 'popover-class show-button title-right footer-right',
            title: 'Toggle on it to see the translated text',
            position: 'bottom-right',
          }
        },
        {
          element: ".buttons-audio",
          popover: {
            className: 'popover-class show-button popover-last title-left footer-left',
            title: 'click to Play',
            position: 'top',
          }
        }
        ]);
      }
      
      setTimeout(() => {
        this.driver.start();
      },300)
    }
  },
}
</script>


<style scoped>
  .bg-main.driver-fix-stacking .container {
      overflow-y: hidden;
      height: calc(100vh - 267px);
  }
  .sticky.driver-fix-stacking {
      position: absolute !important;
      bottom: 0;
    z-index: 100002 !important;
  }
  
  .driver-fix-stacking .buttons-audio {
    z-index: 100004 !important;
  }
</style>
